export const timeAxisHeaderMenuFeature = {
    items: {
        zoomLevel: false,
        dateRange: false,
        currentTimeLine: false
    }
};